import React, { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonVariant = "primary" | "warning" | "danger" | "quiet";

interface SettingButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className"> {
  variant?: ButtonVariant;
  icon?: ReactNode;
  className?: string;
}

const SettingButton: React.FC<SettingButtonProps> = ({
  variant = "primary",
  icon,
  children,
  className,
  type = "button",
  ...rest
}) => {
  const base = "settings-page__action-button";
  const variantClass = `${base}--${variant}`;
  const classes = [base, variantClass, className].filter(Boolean).join(" ");

  return (
    <button type={type} className={classes} {...rest}>
      {icon !== undefined && <span className="settings-page__action-icon">{icon}</span>}
      <span className="settings-page__action-text">{children}</span>
    </button>
  );
};

export default SettingButton;


